"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @param {Recover} recover A reference to the Recover class
 * @param {number} debtId A reference to a single debt
 * @class DebtSupportingDocuments
 * @classdesc Handles a debts supporting documents
 */
var DebtSupportingDocuments = /** @class */ (function () {
    function DebtSupportingDocuments(recover, debtId) {
        var _this = this;
        this.recover = recover;
        this.debtId = debtId;
        /**
         *
         *
         * @memberof DebtSupportingDocuments
         * @returns {SuccessfulGetSupportingDocuments} Returns all supporting documents for a single debt.
         * @descrption Returns all supporting documents for a single debt
         */
        this.index = function () {
            return _this.recover.request("/debts/" + _this.debtId + "/supporting_documents", 'GET', null, null);
        };
        /**
         *
         *
         * @memberof DebtSupportingDocuments
         * @returns {SuccessfulPostSupportingDocuments} Returns a message and information on the supporting document
         * @property {Formdata} supportingDocuments Formdata containing the file
         * @description Creates a new supporting document
         */
        this.create = function (supportingDocuments) {
            return _this.recover.request("/debts/" + _this.debtId + "/supporting_documents", 'POST', supportingDocuments, null);
        };
    }
    return DebtSupportingDocuments;
}());
exports.default = DebtSupportingDocuments;
